/*
Header names carrying the browser's PostHog session recording identity to the
server, so BACKEND errors raised by a browser's API call can link to the same
session recording that frontend errors already link to (SP-2434). Shared by
the client sender (client/utils/sentryPosthogLink.ts) and the server-side
enrichment (server/lib/posthogRequestLink.ts) so the two can't drift.
*/

export const POSTHOG_SESSION_ID_HEADER = "x-posthog-session-id";
export const POSTHOG_REPLAY_URL_HEADER = "x-posthog-replay-url";
